import React from 'react'
import styles from "./../Login.module.scss";

type Props = {
    title: string;
    subtitle?: string;
}

const LoginHeading = (props: Props) => {
    const { title, subtitle } = props;
    return (
        <div className={`text-center ${styles.headerTop}`}>
            <h2 className="font-weight-semi-bold mb-1">
                {title}
            </h2>
            {subtitle && <p className="font-size-18">
                {subtitle}
            </p>}
        </div>
    )
}

export default LoginHeading